import { Insight, PeriodicStats, TrendDetail } from '@fullstory/proto/fs/api/proactiveinsights';
import { int64, Timestamp } from '@fullstory/proto/google/protobuf';
import { InsightJson, TrendJson } from './types';
import { DataRow } from '@fullstory/proto/fs/api/metrics';
export function insightJsonToProto(jsonInsight: InsightJson): Insight {
  const trend: TrendDetail | undefined = jsonInsight.trend
    ? getTrendFromJson(jsonInsight.trend)
    : undefined;
  return {
    ...jsonInsight,
    dxObject: {
      ...jsonInsight.dxObject,
      version: stringToInt(jsonInsight.dxObject.version),
    },
    computedAt: stringToDate(jsonInsight.computedAt),
    start: stringToDate(jsonInsight.start),
    end: stringToDate(jsonInsight.end),
    createdAt: stringToDate(jsonInsight.createdAt),
    updatedAt: stringToDate(jsonInsight.updatedAt),
    alertMetadata: jsonInsight.alertMetadata ?? null,
    trend,
  };
}

const stringToDate = (string: string) => Timestamp.fromDate(new Date(string));
const stringToInt = (string: string) => int64.fromNumber(parseInt(string, 10));
const stringNumberToNumber = (stringNumber: string | number) =>
  typeof stringNumber === 'string' ? parseFloat(stringNumber) : stringNumber;

const getTrendFromJson = (trendJson: TrendJson): TrendDetail => {
  const dataRows = trendJson.data.metricsDataTable.table.map(
    (row): DataRow => ({
      ...row,
      startTime: stringToDate(row.startTime),
      endTime: stringToDate(row.endTime),
      value: stringNumberToNumber(row.value),
      defaultValue: 0,
      isPartialPeriod: row.isPartialPeriod,
    }),
  );
  const periodicStats: PeriodicStats[] = trendJson.periodicStats.map(stat => ({
    ...stat,
    startDate: stringToDate(stat.startDate),
    endDate: stringToDate(stat.endDate),
    variability: stat.variability
      ? {
          stdUpper: stringNumberToNumber(stat.variability.stdUpper),
          stdLower: stringNumberToNumber(stat.variability.stdLower),
        }
      : undefined,
  }));
  return {
    ...trendJson,
    data: {
      metricsDataTable: {
        table: dataRows,
        numGroups: stringToInt(trendJson.data.metricsDataTable.numGroups),
      },
    },
    periodicStats,
    trendSteps: null,
  };
};
